import {
  ADD_TAG,
  ADD_TAGS,
  DELETE_ALL_TAGS,
  DELETE_TAG,
  DISABLE_TAG,
  ENABLE_TAG,
  SELECT_TAG,
  SET_TAG_NUMBER,
  TagsAction,
  UNSELECT_TAG,
  UPDATE_TAGS,
} from "../types";

import { Tag } from "../../types";

const initialState: { [key: string]: Tag } = {};

export default (
  state: { [key: string]: Tag } = initialState,
  action: TagsAction
) => {
  switch (action.type) {
    case ADD_TAGS:
      return { ...action.payload };
    case UPDATE_TAGS:
      let updatedTags = action.payload;
      Object.keys(state).map((id) => {
        if (id in updatedTags) {
          updatedTags[id].selected = state[id].selected;
          updatedTags[id].disabled = state[id].disabled;
          updatedTags[id].number = state[id].number;
          updatedTags[id].shared = state[id].shared;
        }
      });
      return Object.assign(updatedTags);
    case ADD_TAG:
      return { ...state, [action.payload.id]: action.payload.tag };
    case SELECT_TAG:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          selected: true,
        },
      };
    case UNSELECT_TAG:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          selected: false,
        },
      };
    case DISABLE_TAG:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          disabled: true,
        },
      };
    case ENABLE_TAG:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          disabled: false,
        },
      };
    case SET_TAG_NUMBER:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          number: action.payload.number,
          disabled: action.payload.number === 0 ? true : false,
        },
      };
    case DELETE_TAG:
      return state;
    case DELETE_ALL_TAGS:
      return {};
    default:
      return state;
  }
};
